module.exports = __webpack_public_path__ + "assets/7f799fd2e244b61fa594db17c1e95dd6.png";